import { withTransition } from "../../decorators/index.js";
import { AbstractSliderChild } from "./AbstractSliderChild.js";
class SliderDots extends withTransition(AbstractSliderChild) {
  /**
   * Config.
   */
  static config = {
    name: "SliderDots",
    refs: ["dots[]"]
  };
  /**
   * Get target.
   * @returns {HTMLButtonElement[]}
   */
  get target() {
    return this.$refs.dots;
  }
  /**
   * The current active index.
   */
  currentIndex = 0;
  /**
   * Update dots classes according to the new index.
   * @param   {number} index
   * @returns {void}
   */
  update(index) {
    this.leave(this.$refs.dots[this.currentIndex]);
    this.enter(this.$refs.dots[index]);
    this.currentIndex = index;
  }
  /**
   * Go to the given index on dot click.
   */
  onDotsClick(event, index) {
    this.$parent.goTo(index);
  }
}
export {
  SliderDots
};
//# sourceMappingURL=SliderDots.js.map
